import { Link } from "react-router-dom";

const PaymentCancel = () => {
  return (
    <div
      data-testid="payment-cancel-page"
      className="min-h-screen bg-[var(--bg)] text-[var(--ink)] flex items-center justify-center px-6 py-20"
    >
      <div className="max-w-lg w-full border border-[var(--ink)] bg-[var(--card-bg)] p-10 text-center">
        <span className="label-caps text-[10px] text-[var(--ink)]/60">
          Bare Essentials &bull; Skincare Refined
        </span>
        <h1 className="serif-head text-3xl text-[var(--ink)] mt-4 mb-3">Checkout cancelled</h1>
        <p className="text-xs text-[var(--ink)]/70 font-light mb-6">
          No charge was made. Your selection is saved in your cart whenever you are ready.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-to-store-link"
          className="inline-block border border-[var(--ink)] bg-[var(--ink)] text-[var(--bg)] px-8 py-3 label-caps text-[10px] hover:bg-transparent hover:text-[var(--ink)] transition-colors"
        >
          Return to the Scents
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
